/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState, useEffect } from 'react';
import customStyles from "../../../../assets/styles/customStyles";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import clsx from "clsx";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { Image, Dropdown, Menu } from "antd";
import { NavLink } from "react-router-dom";
import { SelectedIcon, UnSelectedIcon } from "../Icons/selectedIcon";
import { Row, Col } from "antd";
import { currencyFormatInt, downloadImageCommon, exportChatFile } from "../../../../helpers/utilities";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export const Top5Customers = (props) => {
    const { title, details } = props;
    const [type, setType] = useState('invoiceAmount');
    const [others, setOthers] = useState({});
    const Top5Customers = useRef(null);
    const classes = customStyles();
    const titleRef = useRef(null);
    const [height, setHeight] = useState('');


    useEffect(() => {
        calculateOthers(type);
        meterChart();
    }, [details]);


    useEffect(() => {
        let h = `calc(100% - ${titleRef.current.clientHeight + 15}px)`;
        setHeight(h);
    }, [titleRef]);

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(Top5Customers.current, title, type);
        }
    }

    const exportFile = () => {
        let newHead = [['Name', 'Amount', 'Counts', 'Amount Percentage', 'Count Percentage']];
        details?.currentMonth_top_saled_customer?.length > 0 && details?.currentMonth_top_saled_customer?.map((data, i) => {
            newHead[i + 1] = [data.customer, data.invoiceAmount, data.invoiceCount, data.amountPercentage, data?.countPercentage];
        });
        exportChatFile(`${title}`, newHead);
    }

    const meterChart = (div, data) => {
        let chart = am4core.create(div, am4charts.GaugeChart);
        let axis = chart.xAxes.push(new am4charts.ValueAxis());
        axis.min = 0;
        axis.max = 100;

        axis.strictMinMax = true;
        axis.renderer.inside = true;
        axis.renderer.innerRadius = -14;
        chart.chartContainer.marginTop = -20;
        axis.renderer.line.strokeLinecap = "round";
        axis.renderer.radius = am4core.percent(85);
        //    / axis.renderer.radius = 40;
        axis.renderer.line.strokeOpacity = 1;
        axis.renderer.line.strokeWidth = 5;
        axis.renderer.line.stroke = "#317787";
        axis.renderer.labels.template.disabled = true;
        axis.renderer.grid.template.stroke = "#ffc27a";
        axis.renderer.grid.template.strokeWidth = 1.5;
        axis.renderer.grid.template.strokeOpacity = 1;
        axis.renderer.grid.template.strokeLinecap = "round";
        var hand = chart.hands.push(new am4charts.ClockHand());
        hand.fill = axis.renderer.line.stroke;
        hand.stroke = axis.renderer.line.stroke;
        hand.axis = axis;
        hand.radius = "75%";
        hand.pin.radius = 5;
        hand.pin.fill = "#ffc27a";
        hand.pin.stroke = "#317787";
        hand.pin.strokeWidth = 5;
        hand.startWidth = 6;
        hand.innerRadius = 5;
        hand.showValue(data, am4core.ease.cubicOut);

    }

    const handleChange = (value) => {
        calculateOthers(value);
        setType(value);
    }

    const calculateOthers = (value) => {
        let allTotalInvoiceAmount = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value])?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.invoiceAmount)), 0);
        let totalInvoiceAmount = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value]).slice(0, 5)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.invoiceAmount)), 0);

        let allTotalInvoiceCount = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value])?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.invoiceCount)), 0);
        let totalInvoiceCount = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value]).slice(0, 5)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.invoiceCount)), 0);

        let allTotalInvoiceCountPercentage = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value])?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.countPercentage)), 0);
        let totalInvoiceCountPercentage = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value]).slice(0, 5)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.countPercentage)), 0);

        let allTotalInvoiceAmountPercentage = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value])?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.amountPercentage)), 0);
        let totalInvoiceAmountPercentage = details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value]).slice(0, 5)?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.amountPercentage)), 0);



        details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value]).slice(0, 5).map((data, i) => {
            return meterChart(`chartDiv${i + 1}`, data[value === 'invoiceAmount' ? 'amountPercentage' : 'countPercentage']);
        });

        if (details?.currentMonth_top_saled_customer.sort((a, b) => b[value] - a[value])?.length > 5) {
            setOthers({
                amountPercentage: allTotalInvoiceAmountPercentage - totalInvoiceAmountPercentage,
                countPercentage: allTotalInvoiceCountPercentage - totalInvoiceCountPercentage,
                invoiceAmount: allTotalInvoiceAmount - totalInvoiceAmount,
                invoiceCount: allTotalInvoiceCount - totalInvoiceCount,
            });
            meterChart(`chartDiv6`, value === 'invoiceAmount' ? (allTotalInvoiceAmountPercentage - totalInvoiceAmountPercentage) :
                (allTotalInvoiceCountPercentage - totalInvoiceCountPercentage))
        }
    }


    return (
        <div ref={Top5Customers} className={clsx(classes.totalChartDiv, classes.totalChartDivCustomers)}>
            <div ref={titleRef}>
                <div className={clsx(classes.monthlyDivTitle, classes.bold, classes.monthlyDivTitleCustomer)}><span className={classes.monthlyDivTitleSpan}>{title}</span>
                    <span className={classes.lastDaysRadioSupply}>
                        <RadioGroup
                            row
                            defaultValue={"invoiceAmount"}
                            onChange={(e) => handleChange(e.target.value)}>
                            <FormControlLabel value="invoiceAmount" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="By Value" />
                            <FormControlLabel value="invoiceCount" control={<Radio
                                checkedIcon={<UnSelectedIcon />}
                                icon={<SelectedIcon />}
                            />} label="By Counts" />
                        </RadioGroup>
                    </span>
                    {
                        type === 'invoiceAmount' ?
                            <span className={classes.totalSales}>Total Sales <span>₹ {currencyFormatInt(details?.currentMonthSalesAmount)}</span></span> :
                            <span className={classes.totalSales}>Total Counts <span>{details?.currentMonthSalesInvoice}</span></span>
                    }
                    <span className={classes.hamburgerMenu}>
                        <Dropdown
                            placement="bottomLeft"
                            trigger={['click']}
                            overlay={
                                <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                    <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                                </Menu>
                            }>
                            <Image src={hamburgerMenu} preview={false} />
                        </Dropdown>
                    </span>
                </div>
            </div>
            <Row gutter="6" className={classes.customerRowMain} style={{ height: height }}>
                {
                    details?.currentMonth_top_saled_customer.sort((a, b) => b[type] - a[type]).slice(0, 5).map((data, i) => (
                        <Col className={classes.customerRowCol} xxl={12} xl={12} lg={24} md={24} sm={24} xs={24} key={i}>
                            <div className={clsx(classes.customesRow)}>
                                <div className={classes.customesRowTitle} title={data?.customer}>{data?.customer}</div>
                                <div id={`chartDiv${i + 1}`} className={classes.gaugeChartDiv}></div>
                                <div className={clsx(classes.customesRowContent, `customesRowContent_${i + 1}`)}>
                                    <span className={classes.customesRowContentCount}>0{i + 1}</span>
                                    <span className={classes.customesRowContentAmount}>{type === 'invoiceAmount' ? `₹ ${currencyFormatInt(data?.invoiceAmount)}` : data?.invoiceCount}</span>
                                    <span className={classes.customesRowContentPercentage}>{(data[type === 'invoiceAmount' ? 'amountPercentage' : 'countPercentage']).toFixed(2)}%</span>
                                </div>
                            </div>
                        </Col>
                    ))
                }
                {
                    details?.currentMonth_top_saled_customer?.length > 5 &&
                    <Col className={classes.customerRowCol} xxl={12} xl={12} lg={24} md={24} sm={24} xs={24}>
                        <div className={classes.customesRow}>
                            <div className={classes.customesRowTitle}>Others</div>
                            <div id={`chartDiv6`} className={classes.gaugeChartDiv}></div>
                            <div className={clsx(classes.customesRowContent, `customesRowContent_6`)}>
                                <span className={classes.customesRowContentCount}>06</span>
                                <span className={classes.customesRowContentAmount}>{type === 'invoiceAmount' ? `₹ ${currencyFormatInt(others?.invoiceAmount)}` : others?.invoiceCount}</span>
                                <span className={classes.customesRowContentPercentage}>{(others[type === 'invoiceAmount' ? 'amountPercentage' : 'countPercentage'])?.toFixed(2)}%</span>
                            </div>
                        </div>
                    </Col>
                }

                {/* <Col span={12}>
                    <div className={classes.customesRow}>
                        <div className={classes.customesRowTitle}>Vetrivel Traders</div>
                        <div className={clsx(classes.customesRowContent, classes.customesRowContent_2)}>
                            <span className={classes.customesRowContentCount}>01</span>
                            <span className={classes.customesRowContentAmount}>₹ 4,00,000</span>
                            <span className={classes.customesRowContentPercentage}>40%</span>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div className={classes.customesRow}>
                        <div className={classes.customesRowTitle}>Vetrivel Traders</div>
                        <div className={clsx(classes.customesRowContent, classes.customesRowContent_3)}>
                            <span className={classes.customesRowContentCount}>01</span>
                            <span className={classes.customesRowContentAmount}>₹ 4,00,000</span>
                            <span className={classes.customesRowContentPercentage}>40%</span>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div className={classes.customesRow}>
                        <div className={classes.customesRowTitle}>Vetrivel Traders</div>
                        <div className={clsx(classes.customesRowContent, classes.customesRowContent_4)}>
                            <span className={classes.customesRowContentCount}>01</span>
                            <span className={classes.customesRowContentAmount}>₹ 4,00,000</span>
                            <span className={classes.customesRowContentPercentage}>40%</span>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div className={classes.customesRow}>
                        <div className={classes.customesRowTitle}>Vetrivel Traders</div>
                        <div className={clsx(classes.customesRowContent, classes.customesRowContent_5)}>
                            <span className={classes.customesRowContentCount}>01</span>
                            <span className={classes.customesRowContentAmount}>₹ 4,00,000</span>
                            <span className={classes.customesRowContentPercentage}>40%</span>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div className={classes.customesRow}>
                        <div className={classes.customesRowTitle}>Vetrivel Traders</div>
                        <div className={clsx(classes.customesRowContent, classes.customesRowContent_6)}>
                            <span className={classes.customesRowContentCount}>01</span>
                            <span className={classes.customesRowContentAmount}>₹ 4,00,000</span>
                            <span className={classes.customesRowContentPercentage}>40%</span>
                        </div>
                    </div>
                </Col> */}
            </Row>
        </div>
    )
}